import React, { useState, useEffect } from "react";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { categoryPost } from "../../../redux/category/CategorySlice";
import { MdGTranslate } from "react-icons/md";

const AddCategory = () => {
  const [categoryTelugu, setCategoryTelugu] = useState("");
  const [categoryEnglish, setCategoryEnglish] = useState("");
  const [categoryPriority, setCategoryPriority] = useState(20);
  const [publishForUsers, setPublishForUsers] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [checkslugUrl, setCheckSlugUrl] = useState("");
  const dispatch = useDispatch();
  const { allCategorys } = useSelector((store) => store.category);

  const checkSlugExists = (slug) => {
    return allCategorys.some((item) => item.slugUrl === slug);
  };

  // Function to capitalize the first letter
  const capitalizeFirstLetter = (value) => {
    return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Handle input change and ensure the first letter is uppercase
  const handleChange = (setter) => (e) => {
    setter(capitalizeFirstLetter(e.target.value));
  };

  const translateAllFields = async () => {
    const translateText = async (text, sourceLang, targetLang) => {
      if (!text) return "";
      const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(
        text
      )}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        return data[0][0][0] || text;
      } catch (error) {
        console.error("Translation error", error);
        return text;
      }
    };

    const isTelugu = /[\u0C00-\u0C7F]/.test(categoryTelugu || categoryEnglish);
    const sourceLang = isTelugu ? "te" : "en";
    const targetLang = isTelugu ? "en" : "te";

    const [translatedTitle] = await Promise.all([
      translateText(categoryTelugu || categoryEnglish, sourceLang, targetLang),
    ]);

    setCategoryTelugu(sourceLang === "te" ? categoryTelugu : translatedTitle);
    setCategoryEnglish(sourceLang === "en" ? categoryEnglish : translatedTitle);
  };

  // Generate slug from categoryEnglish
  useEffect(() => {
    if (categoryEnglish) {
      const slug = categoryEnglish
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with '-'
        .replace(/[^a-z0-9-]/g, "") // Remove special characters except '-'
        .replace(/-{2,}/g, "-") // Replace multiple '-' with a single '-'
        .replace(/^-+|-+$/g, ""); // Remove '-' from start or end

      if (checkSlugExists(slug)) {
        setCheckSlugUrl("error");
      } else {
        setCheckSlugUrl(slug);
      }
    }
  }, [categoryEnglish, allCategorys]); // Add allCategorys as dependency

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);

    try {
      if (
        categoryTelugu !== "" &&
        categoryEnglish !== "" &&
        checkslugUrl !== ""
      ) {
        const formData = {
          nameInTelugu: categoryTelugu,
          nameInEnglish: categoryEnglish,
          slugUrl: checkslugUrl,
          priority: categoryPriority,
          status: publishForUsers,
        };
        const data = await dispatch(categoryPost(formData));
        if (data.payload.success) {
          toast.success("Category added successfully!", {
            position: "top-right",
          });

          setCategoryTelugu("");
          setCategoryEnglish("");
          setCategoryPriority(1);
          setPublishForUsers(false);
          setCheckSlugUrl("");
        } else {
          toast.error("Category Name (English) already exists!", {
            position: "top-right",
          });
        }
      } else {
        toast.error("Please fill all required fields!", {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", { position: "top-right" });
    } finally {
      setBtnLoading(false);
    }
  };

  const LoadingButton = styled(Button)({
    position: "relative",
  });

  const LoadingIndicator = styled(CircularProgress)({
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  });

  return (
    <div className="main_fragnent_container p-2">
      <div className="profile_container_header">
        <div className="profile_co_header_left">
          <span>Add Category</span>
        </div>
      </div>
      <div className="main_recha_container">
        <div className="translate_container">
          <button className="translate_btn" onClick={translateAllFields}>
            <MdGTranslate className="translate_icon" />
            <span className="translate_text">Click to Translate</span>
          </button>
        </div>
        <div className="inputs_container">
          <div className="dn_input_box">
            <TextField
              label="Category Name In Telugu"
              type="text"
              className="input_style"
              autoComplete="off"
              size="small"
              value={categoryTelugu}
              onChange={handleChange(setCategoryTelugu)}
            />
          </div>
          <div className="dn_input_box">
            <TextField
              label={
                checkslugUrl === "error"
                  ? "Category Already Exists"
                  : "Category Name In English"
              }
              type="text"
              className="input_style"
              autoComplete="off"
              size="small"
              error={checkslugUrl === "error"}
              value={categoryEnglish}
              onChange={handleChange(setCategoryEnglish)}
            />
          </div>
          <div className="dn_input_box">
            <FormControl fullWidth size="small">
              <InputLabel>Category Priority</InputLabel>
              <Select
                value={categoryPriority}
                onChange={(e) => setCategoryPriority(e.target.value)}
                label="Category Priority"
              >
                {Array.from({ length: 20 }, (_, i) => (
                  <MenuItem key={i + 1} value={i + 1}>
                    {i + 1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="dn_input_box_new">
            <div className="input_style">
              <h6>Publish Category For Menu</h6>
              <div className="checkbox-wrapper-6">
                <input
                  className="tgl tgl-light"
                  id="cb1-6"
                  type="checkbox"
                  checked={publishForUsers}
                  onChange={() => setPublishForUsers(!publishForUsers)}
                />
                <label className="tgl-btn" htmlFor="cb1-6"></label>
              </div>
            </div>
          </div>
        </div>
        <div className="button_container">
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <>
                Loading
                <LoadingIndicator size={24} />
              </>
            ) : (
              "Update"
            )}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
